import React from "react";
import { Navigate } from "react-router-dom";
import { useBoardId } from "@contexts/BoardContext";
import { readLastBoardView } from "./BoardLastView.ViewModel";

/**
 * The board's index route: sends you to whichever of its two views you had open
 * last, rather than always to the kanban.
 *
 * A redirect rather than rendering the right view in place, so the address bar
 * names the view you are in — the toggle, a bookmark and the back button all
 * depend on the two having their own URLs.
 *
 * Replaces rather than pushes: the bare board URL is a staging post, and
 * leaving it in the history would make Back bounce straight through it again.
 */
const BoardLastViewRedirect: React.FC = () => {
  const boardId = useBoardId();

  return (
    <Navigate
      to={readLastBoardView(boardId) === "schedule" ? "schedule" : "tasks"}
      replace
    />
  );
};

export default BoardLastViewRedirect;
